import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
//import {HttpModule} from '@angular/http';

import {FormsModule,ReactiveFormsModule} from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { NavbarComponent } from './navbar/navbar.component';

import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CategoryComponent } from './category/category.component';
import { AuthService } from './services/auth.service';
import { PagerService } from './services/pager.service';
import { ProjectComponent } from './project/project.component';
import { MailerComponent } from './mailer/mailer.component';
import { TemplateComponent } from './template/template.component';
import { LoginComponent } from './login/login.component';



@NgModule({
  declarations: [
    AppComponent,    
    NavbarComponent, FooterComponent, TopbarComponent, DashboardComponent, CategoryComponent, ProjectComponent, MailerComponent, TemplateComponent, LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    //HttpModule,
    FormsModule,
    ReactiveFormsModule,
   
  ],
  
  providers: [AuthService,PagerService],
  bootstrap: [AppComponent]
})


export class AppModule { }



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/app.module.ts